import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const styles = makeStyles({
  setButton: {
    marginTop: '10px',
    width: '124px',
    height: '32px',
  },
  setButtonDark: {
    marginTop: '10px',
    width: '124px',
    height: '32px',
    backgroundColor: '#9C27B0',
  },
  cancelButton: {
    width: '82px',
    height: '32px',
    marginTop: '10px',
  },
  cancelButtonDark: {
    marginTop: '10px',
    width: '82px',
    height: '32px',
    border: '1px solid #A8A8A8',
    backgroundColor: 'transparent',
    '& .MuiButton-label': {
      color: '#A8A8A8',
    },
    '&:hover': {
      background: 'transparent',
    },
  },
  footerMessage: {
    marginTop: '15px',
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});
const AdvancedSettingsFooter = props => {
  const { handleModalClose, handleSetCriteria, disabled } = props;
  const classes = styles();
  const theme = useTheme();

  return (
    <>
      <Grid container spacing={2} className={classes.dialogActions}>
        <Grid item xs={2}>
          <Button
            variant="contained"
            onClick={handleModalClose}
            fullWidth
            className={theme.palette.type === 'light' ? classes.cancelButton : classes.cancelButtonDark}
          >
            <Typography style={{ marginTop: '3px' }}>CANCEL</Typography>
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSetCriteria()}
            fullWidth
            disabled={disabled}
            className={theme.palette.type === 'light' ? classes.setButton : classes.setButtonDark}
          >
            <Typography style={{ marginTop: '3px' }}>SET CRITERIA</Typography>
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

AdvancedSettingsFooter.propTypes = {
  handleModalClose: PropTypes.func.isRequired,
  handleSetCriteria: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default AdvancedSettingsFooter;
